import { ICustomerPlanSetup } from './types';
import { ICustomerPlanFieldsFragment } from '../../../utils/apollo/graphqlSchema';

export const toCustomerPlan = (
  customerPlan: ICustomerPlanFieldsFragment,
): ICustomerPlanSetup => {
  const { maxSeats, maxSchemas } = customerPlan;
  // if no maxSchema model is provided then the customer has unlimited schemas
  const hasAvailableSchemas = !maxSchemas
    ? true
    : maxSchemas.availableSchemas > 0;

  const reachMaxSeats = !maxSeats ? false : maxSeats.availableSeats <= 0;
  return {
    maxSeats,
    maxSchemas,
    hasAvailableSchemas,
    reachMaxSeats,
    mtuPlan: customerPlan.mtuPlan,
  };
};
